// extracted by mini-css-extract-plugin
export default {"regFormsContainer":"RegFormsContainer_regFormsContainer__JZpxd"};